import { localStorageAdapter } from "@/betby/adapters/storage/storageAdapter";
import { getAppConfig } from "@/betby/infrastructure/config/appConfig";
import { getHttpRuntime } from "@/betby/infrastructure/http/httpRuntime";

let cachedDeviceId: string | null = null;
let lastDeviceIdStorageKey: string | null = null;

export function getDeviceId(): string {
  const runtimeDeviceId = getHttpRuntime().getDeviceId?.();
  if (runtimeDeviceId) {
    return runtimeDeviceId;
  }

  if (typeof window === "undefined") {
    return "server-device-id";
  }

  const deviceIdStorageKey = getAppConfig().storage.deviceIdKey;
  if (lastDeviceIdStorageKey !== deviceIdStorageKey) {
    cachedDeviceId = null;
    lastDeviceIdStorageKey = deviceIdStorageKey;
  }

  if (cachedDeviceId) {
    return cachedDeviceId;
  }

  let deviceId = localStorageAdapter.getItem(deviceIdStorageKey);
  if (!deviceId) {
    deviceId = `device-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorageAdapter.setItem(deviceIdStorageKey, deviceId);
  }

  cachedDeviceId = deviceId;
  return deviceId;
}
